<template>
  <div class="home">
    <div class="section-2">
      <v-card color="white" class="px-4 px-md-0" width="100%" flat>
        <v-container class="py-8 py-md-15">
          <v-row>
            <!-- A loan that works for you -->
            <v-col cols="12">
              <h3 class="heading-h3 mb-md-2">
                Tailored Short Term Loans Online
              </h3>
            </v-col>

            <!-- carousel -->
            <v-col
              class="hidden-xs-only"
              v-for="(listItem, index) in listItems"
              :key="index"
              cols="12"
              sm="4"
              lg="4"
            >
              <div class="d-flex align-start">
                <v-icon :color="'#08338F'" size="24" class="mt-2">{{
                  listItem.icon
                }}</v-icon>

                <!-- Text -->
                <div class="ml-3 mt-1">
                  <h4 class="heading-h4 font-weight-bold mb-2">
                    {{ listItem.title }}
                  </h4>

                  <p class="b-body-1" v-html="listItem.description"></p>
                </div>
              </div>
            </v-col>

            <!-- carousel -->
            <v-col class="hidden-sm-and-up" cols="12">
              <v-carousel
                :continuous="false"
                :show-arrows="false"
                height="auto"
                delimiter-icon=""
                hide-delimiter-background
                class="cssClass pb-4"
              >
                <v-carousel-item
                  v-for="(listItem, index) in listItems"
                  :key="index"
                  reverse-transition="fade-transition"
                  transition="fade-transition"
                >
                  <div class="d-flex align-start">
                    <v-icon :color="'#08338F'" size="24" class="mt-2">{{
                      listItem.icon
                    }}</v-icon>

                    <!-- Text -->
                    <div class="ml-3">
                      <h4 class="heading-h4 font-weight-bold">
                        {{ listItem.title }}
                      </h4>

                      <p class="b-body-1" v-html="listItem.description"></p>
                    </div>
                  </div>
                </v-carousel-item>
              </v-carousel>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
// import img1 from "@/assets/img/public/pages/home/section-2/pen.svg";
// import img2 from "@/assets/img/public/pages/home/section-2/globe.svg";
// import img3 from "@/assets/img/public/pages/home/section-2/wallet.svg";

export default {
  name: "LimeLoansSection2",

  data() {
    return {
      listItems: [
        {
          icon: "mdi-pencil",
          title: "Create Your Personal Profile",
          description: `Begin your loan application with a one-time registration. You'll need to provide the following details:<br /><br />
            <ul>
              <li>Full name and surname</li>
              <li>ID number</li>
              <li>Mobile phone number</li>
              <li>Email address</li>
              </ul>
            `,
        },
        {
          icon: "mdi-earth",
          title: "During Your Loan Conditions",
          description: `During your loan application, you'll be able to choose your preferred loan amount and repayment term.<br /><br />
          Once you've uploaded your latest 3 months bank statemnets (reflecting you most recent three salary deposits), we'll assess your application and send you an initial loan offer<br /><br />
          As your borrowing history grows, your future loan offers may increase, subject to your affordability`,
        },
        {
          icon: "mdi-wallet",
          title: "Your Loan Disbursement",
          description: `Once you've signed your agreement and authenticated your DebitCheck mandate, we will disburse the funds directly into your bank account.<br /><br />
          We aim to approve and disburse loan applications on the same day<br /><br /
          Enjoy a smooth and reliable personal loan experince with Century Financial Services`,
        },
      ],
    };
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 600px) {
  .b-body-1 {
    //styleName: 14 S/normal;
    font-size: 14px;
    line-height: 21px;
    letter-spacing: 0.01em;
  }
}
</style>
